import { useQueryClient } from "@tanstack/react-query";

export default function useCache() {
  const queryClient = useQueryClient();

  const clearCache = async () => {
    await queryClient.refetchQueries();
  };

  return {
    clearCache,
  };
}
